define( function() {
	return ( /^\s+/ );
} );



// WEBPACK FOOTER //
// ./~/jquery/src/manipulation/var/rleadingWhitespace.js